import { graphql } from "@/graphql/generated/gql";

// ============== QUERIES ======================
export const getStatusListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query GetStatusListForWorkspace($input: GetStatusListForWorkspaceInput!) {
    statusListForWorkspace(getStatusListForWorkspaceInput: $input) {
      ...StatusFields
      instanceList {
        ...StatusInstanceFields
      }
    }
  }
`);

// ============== MUTATIONS ======================
export const createStatusMutationDocument = graphql(/* GraphQL */ `
  mutation createStatus($input: CreateStatusInput!) {
    createStatus(createStatusInput: $input) {
      ...StatusFields
      instanceList {
        ...StatusInstanceFields
      }
    }
  }
`);

export const updateStatusMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateStatus($input: UpdateStatusInput!) {
    updateStatus(updateStatusInput: $input) {
      ...StatusFields
    }
  }
`);

export const deleteStatusMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteStatus($input: DeleteStatusInput!) {
    deleteStatus(deleteStatusInput: $input) {
      ...StatusFields
    }
  }
`);

export const reorderStatusMutationDocument = graphql(/* GraphQL */ `
  mutation ReorderStatus($input: ReorderStatusInput!) {
    reorderStatus(reorderStatusInput: $input) {
      ...StatusFields
    }
  }
`);
